import React from 'react';
import EmailTemplateBuilder from './EmailTemplateBuilder';

const EmailTemplate = () => {
  return <EmailTemplateBuilder />;
};

export default EmailTemplate;